import React, { useEffect, useState } from "react";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer"
import transport1 from "../../Images/transport/bannertransport.webp"
import transport2 from "../../Images/transport/university-bus.webp"
import bannerImage from '../../Images/transport/university-buses.webp';

const steps = [
    { icon: "🏭", label: "Warehouse" },
    { icon: "🚚", label: "In Transit" },
    { icon: "📍", label: "Nearby Hub" },
    { icon: "🏠", label: "Delivered" },
];

const Transport = () => {
    const routes = {
        'Mahasamund to Campus via Khatti': [
            { route: 'Mahasamund', amount: 2000 },
            { route: 'Boriyajhar', amount: 1800 },
            { route: 'Khatti', amount: 1600 },
            { route: 'Tusda', amount: 1400 },
            { route: 'Khamhariya', amount: 1300 },
            { route: 'Kokanajhar', amount: 1200 },
            { route: 'Charoda', amount: 1000 },
            { route: 'Mogra', amount: 800 },
            { route: 'Dadargaon', amount: 700 },
            { route: 'Campus', amount: 0 }
        ],

        'Khariyar Road To Campus': [
            { route: 'Khrodh l.d', amount: 2000 },
            { route: 'Narra', amount: 1800 },
            { route: 'Komakhan', amount: 1700 },
            { route: 'Dhora Bhatha', amount: 1600 },
            { route: 'Tullu', amount: 1500 },
            { route: 'Palsi pani', amount: 1400 },
            { route: 'Chorbhatti', amount: 1200 },
            { route: 'Charoda', amount: 1000 },
            { route: 'Mongra', amount: 800 },
            { route: 'Dadargaon', amount: 700 },
            { route: 'Kosumbuda', amount: 700 },
            { route: 'Campus', amount: 0 }
        ],

        'Kopra to Campus via Gariyaband': [
            { route: 'Kopra', amount: 1800 },
            { route: 'Sursabandha', amount: 1800 },
            { route: 'Panduka', amount: 1800 },
            { route: 'Pond', amount: 1600 },
            { route: 'Malgaon', amount: 1500 },
            { route: 'Gariyaband', amount: 1500 },
            { route: 'Kokdi', amount: 1400 },
            { route: 'Kaserudih', amount: 1400 },
            { route: 'Kochvay', amount: 1200 },
            { route: 'Sadak Parsuli', amount: 1000 },
            { route: 'Kharkhara', amount: 800 },
            { route: 'Chhura', amount: 700 },
            { route: 'Campus', amount: 0 }
        ],

        'Rajim to Campus via Fingeshwar': [
            { route: 'Rajim', amount: 2000 },
            { route: 'Koma', amount: 1800 },
            { route: 'Kirvai', amount: 1700 },
            { route: 'Borsi', amount: 1600 },
            { route: 'Purena Mod', amount: 1500 },
            { route: 'Chaitra Mod', amount: 1500 },
            { route: 'Fingeshwar', amount: 1300 },
            { route: 'Borid', amount: 1200 },
            { route: 'Sarkada', amount: 1200 },
            { route: 'Sorid', amount: 1100 },
            { route: 'Amethi', amount: 1100 },
            { route: 'Kasekera', amount: 1100 },
            { route: 'Akalvara', amount: 1000 },
            { route: 'Mudagaon', amount: 1000 },
            { route: 'Parsada', amount: 900 },
            { route: 'Bodra Bandha', amount: 800 },
            { route: 'Kosambuda', amount: 700 },
            { route: 'Campus', amount: 0 }
        ],

        'Gariaband to Campus via Rasela': [
            { route: 'Gariyaband', amount: 1500 },
            { route: 'Kordi', amount: 1400 },
            { route: 'Kaserudih', amount: 1400 },
            { route: 'Kochvay', amount: 1200 },
            { route: 'Sadak Parsuli', amount: 1000 },
            { route: 'Pipperchhedi', amount: 900 },
            { route: 'Ruad', amount: 900 },
            { route: 'Kergaon', amount: 900 },
            { route: 'Russela', amount: 800 },
            { route: 'Kansingi', amount: 700 },
            { route: 'Raksi', amount: 600 },
            { route: 'Nartora', amount: 500 },
            { route: 'Dulla', amount: 500 },
            { route: 'Bhaisamuda', amount: 400 },
            { route: 'Kosmi', amount: 300 },
            { route: 'Campus', amount: 0 }
        ],

        'Rajim to Campus via Tarrighat': [
            { route: 'Belturi', amount: 1800 },
            { route: 'Bhaisatara', amount: 1800 },
            { route: 'Kondkera', amount: 1700 },
            { route: 'Semardih', amount: 1700 },
            { route: 'Tarrighat', amount: 1600 },
            { route: 'Chhuhiya', amount: 1500 },
            { route: 'Jamahi', amount: 1500 },
            { route: 'Junvani', amount: 1400 },
            { route: 'Paktiya', amount: 1400 },
            { route: 'Boirgaon', amount: 1300 },
            { route: 'Madeli', amount: 1200 },
            { route: 'Khairjhitti', amount: 1000 },
            { route: 'Lohjhar', amount: 900 },
            { route: 'Tumgaon', amount: 800 },
            { route: 'Chhura', amount: 700 },
            { route: 'Campus', amount: 0 }
        ],

        'Raipur to Campus': [
            { route: 'Pachpadi', amount: 3500 },
            { route: 'Mana', amount: 3500 },
            { route: 'Abhanpur', amount: 3000 },
            { route: 'Nawapara', amount: 2200 },
            { route: 'Rajim', amount: 2000 },
            { route: 'Koma', amount: 1800 },
            { route: 'Kirvai', amount: 1700 },
            { route: 'Borsi', amount: 1600 },
            { route: 'Purena Mod', amount: 1500 },
            { route: 'Chaitra Mod', amount: 1500 },
            { route: 'Fingeshwar', amount: 1300 },
            { route: 'Borid', amount: 1200 },
            { route: 'Sarkada', amount: 1200 },
            { route: 'Sorid', amount: 1100 },
            { route: 'Amethi', amount: 1100 },
            { route: 'Kasekera', amount: 1100 },
            { route: 'Akalvara', amount: 1000 },
            { route: 'Mudagaon', amount: 1000 },
            { route: 'Parasada', amount: 900 },
            { route: 'Bodra Bandha', amount: 800 },
            { route: 'Kosambuda', amount: 700 },
            { route: 'Campus', amount: 0 }
        ]
    };

    const [activeTab, setActiveTab] = useState(Object.keys(routes)[0]);

    return (
        <React.Fragment>
            <title>ISBM University Bus Services | Convenient Campus Connectivity</title>
            <meta
                name="description"
                content="ISBM University offers a reliable bus transportation service connecting various locations to the campus. Ensure your commute is comfortable and timely."
            />
            <Topnav />
            <section className="section-hero-banner ptb-50" style={{
                backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
            }}>
                <div className="banner-hero-overlay">
                    <div className="container-xxl">
                        <div className="section-hero-content">
                            <h1>Campus Commute Assistance</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <a href="/" style={{ color: "#fff", textDecoration: "none" }}>Home</a>
                                </li>
                                <li className="breadcrumb-item active text-white" aria-current="page">
                                    Transport
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section className="container-xxl ptb-50">
                <Row className="flex-wrap-reverse">
                    <Col md={7}>
                        <div className="row align-items-center">
                            {/* Left Column - Text */}
                            <div className="p-4">
                                <h2 className="fw-bold text-dark">
                                    Unsure About Which Bus To Take?
                                </h2>
                                <div className="underlinetwo mb-3"></div>
                                <p>
                                    The easiest way to plan your trip to our campus using transit - especially if you're unsure about which route to take or what time to take it - is to use the ISBM University Bus Schedule penned below and to contact our city office (+91 93299 32747) in case of any queries. Alternatively, go to maps.google.com and use the Directions tool (be sure to specify "transit" as your mode of travel)!
                                </p>
                                <p>
                                    The easiest way to plan your trip to our campus using transit - especially if you're unsure about which route to take or what time to take it - is to use the ISBM University Bus Schedule penned below and to contact our city office (+91 93299 32747) in case of any queries. Alternatively, go to maps.google.com and use the Directions tool (be sure to specify "transit" as your mode of travel)!
                                </p>
                                <p>
                                    The trip planner will automatically select the best route for you to take, based on your origin and destination - it will even suggest trips operated by local service providers.
                                </p>
                            </div>
                        </div>
                    </Col>

                    <Col md={1}></Col>

                    {/* Job List Section */}
                    <Col md={4} className="tranport-main-img position-relative"> {/* Added position-relative class */}
                        <div className="background-transport-block"></div>
                        <div className="transport-gallery-item large">
                            <img src={transport2} alt="Group 1" />
                        </div>
                    </Col>
                </Row >
            </section >

            <section className="bg-gray-100 py-12 px-6">
                <div className="container-xxl py-5">
                    <div className="row g-4">
                        {/* Bus Schedule */}
                        <div className="col-lg-6">
                            <div className="card shadow border-0">
                                <div className="card-header bg-primary-uni text-white">
                                    <h5 className="mb-0">📍 Transport Route Schedule</h5>
                                </div>
                                <div className="card-body p-0">
                                    <div className="table-responsive">
                                        <table className="table table-striped mb-0 mt-0">
                                            <thead className="table-light">
                                                <tr>
                                                    <th scope="col">Stops</th>
                                                    <th scope="col">Next Bus</th>
                                                </tr>
                                            </thead>
                                            <tbody className="text-center">
                                                <tr><td>Churra</td><td>6.00 AM</td></tr>
                                                <tr><td>Fingeshwar</td><td>7.00 AM</td></tr>
                                                <tr><td>Mahasamund</td><td>7.55 AM</td></tr>
                                                <tr><td>Khatti Khamariya</td><td>8.30 AM</td></tr>
                                                <tr><td>Churra</td><td>9.25 AM</td></tr>
                                                <tr><td>Campus</td><td>3.30 PM</td></tr>
                                                <tr><td>Churra</td><td>4.00 PM</td></tr>
                                                <tr><td>Fingeshwar</td><td>4.45 PM</td></tr>
                                                <tr><td>Mahasamund</td><td>5.15 PM</td></tr>
                                                <tr><td>Khatti Khamariya</td><td>6.00 PM</td></tr>
                                                <tr><td>Churra</td><td>7.00 PM</td></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Contact Info */}
                        <div className="col-lg-6">
                            <div className="card shadow border-0 h-100">
                                <div className="card-header bg-success-uni text-white">
                                    <h5 className="mb-0">📞 Contact & Support</h5>
                                </div>
                                <div className="card-body">
                                    <p className="mb-3">
                                        <strong>For instant arrivals via phone call:</strong><br />
                                        <a href="tel:+919329932747" className="text-decoration-none">+91 93299 32747</a>
                                    </p>
                                    <p>
                                        <strong>Questions, comments or concerns?</strong><br />
                                        <a href="mailto:support@isbmuniversity.edu.in" className="text-decoration-none">support@isbmuniversity.edu.in</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="bg-gray-100 py-12 px-6">
                <div className="container-xxl my-5">
                    <div className="modern-title section-title text-center text-blue mb-5">Bus Transportation Fees</div>

                    {/* Nav Tabs */}
                    <ul className="nav nav-pills mb-3 flex-wrap" role="tablist">
                        {Object.keys(routes).map((routeName, index) => (
                            <li className="nav-item" role="presentation" key={index}>
                                <button
                                    className={`nav-link fees shadow ms-2 ${activeTab === routeName ? 'active' : ''}`}
                                    onClick={() => setActiveTab(routeName)}
                                    type="button"
                                    role="tab"
                                >
                                    {routeName}
                                </button>
                            </li>
                        ))}
                    </ul>

                    {/* Tab Content */}
                    <div className="tab-content">
                        {Object.entries(routes).map(([routeName, stops], index) => (
                            <div
                                key={index}
                                className={`tab-pane fade ${activeTab === routeName ? 'show active' : ''}`}
                                role="tabpanel"
                            >
                                <div className="table-responsive">
                                    <table className="table table-bordered table-hover">
                                        <thead className="table text-white text-center">
                                            <tr><th>Route</th><th>Amount</th></tr>
                                        </thead>
                                        <tbody>
                                            {stops.map((stop, idx) => (
                                                <tr key={idx}>
                                                    <td>{stop.route}</td>
                                                    <td>{stop.amount}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <Footer />
        </React.Fragment>
    );
};

export default Transport;